import styled from "styled-components";

import { Title } from "@/components/Typography";

export const Container = styled.div`
    display: grid;
    grid-template: "steps form" 1fr ". steps-buttons" 44px / 200px 1fr;
    gap: 32px;
    width: 100%;
`;

export const StepsContainer = styled.div`
    grid-area: steps;
`;

export const FormContainer = styled.div`
    grid-area: form;
`;

export const StepsButtonsContainer = styled.div`
    grid-area: steps-buttons;
`;

export const StepTitle = styled(Title)`
    margin-bottom: 24px;
`;
